import { render, staticRenderFns } from "./Newcontact.vue?vue&type=template&id=793a09d5&scoped=true&"
import script from "./Newcontact.vue?vue&type=script&lang=js&"
export * from "./Newcontact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a09d5",
  null
  
)

export default component.exports